module.exports = __webpack_public_path__ + "static/media/diwali-image.e2e10d15.jpg";